import React from 'react';
import {
  Autocomplete,
  TextField,
  Typography,
  Box
} from '@mui/material';
import ValidationErrorText from '../common/ValidationErrorText';

const qualificationOptions = [
  '10th Pass',
  '12th Pass / 10+2',
  'Diploma',
  'Bachelor’s Degree (UG)',
  'Master’s Degree (PG)',
  'M.Phil.',
  'PhD / Doctorate',
  'CA / CS / ICWA',
  'ITI Certificate',
  'Polytechnic Diploma',
  'Equivalent International Qualification',
  'Other (Please specify)',
];

const MinimumQualificationSelect = ({
  label,
  value = '',
  onChange = () => {},
  readOnly = false,
  fieldErrors,
  fieldError,
  fieldType
}) => {
  return (
    <Box sx={{ minWidth: '100%' }}>
      <Typography fontSize="16px" fontWeight="600" mb={1}>
        Qualification
      </Typography>
      {label && (
        <Typography fontSize="14px" fontWeight="500" mb={1}>
          {label}
        </Typography>
      )}

      <Autocomplete
        options={qualificationOptions}
        value={value || ''}
        onChange={(event, newValue) => onChange(newValue || '')}
        fullWidth
        size="small"
        clearOnBlur
        disableClearable={false}
        disabled={readOnly}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select qualification"
            size="small"
            InputProps={{
              ...params.InputProps,
              sx: {
                fontSize: 13,
                height: 38,
              },
            }}
            inputProps={{
              ...params.inputProps,
              style: {
                fontSize: 13,
                padding: '8px 12px',
              },
            }}
          />
        )}
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            padding: '0 !important',
          },
        }}
      />
      <ValidationErrorText error={fieldError}/>
    </Box>
  );
};

export default MinimumQualificationSelect;
